import {
  Attribute,
  FamilyGroup,
  getGroupImages,
  getGroupService,
  Image,
  ProductService,
  ServiceType,
  SFCCProductItem,
} from '@gn-audio/jss-core';

import { GiftWrappingDetails } from '../../../types/giftWrappingApi';

export const mapToBasketService = (s: SFCCProductItem): ProductService => ({
  serviceProductId: s.product_id,
  value: s.c_serviceValue,
});

export const isServiceAllowedForGroup = async (
  group: FamilyGroup,
  serviceType: ServiceType
): Promise<boolean> => {
  const serviceKeys = {
    GIFT_WRAPPING: 'Product_GiftWrapping',
    ENGRAVING: 'Product_Engraving',
  };

  const serviceAttribute: Attribute | undefined = group.attributes?.find(
    (attr) => attr.key === serviceKeys[serviceType]
  );

  return !!serviceAttribute && serviceAttribute.value === 'True';
};

export const getGiftWrappingDetailsForGroup = async (
  groupId: number,
  locale: string
): Promise<GiftWrappingDetails | null> => {
  const giftWrapping = await getGroupService(String(groupId), locale, ServiceType.GiftWrapping);

  if (!giftWrapping?.groupId) return null;
  const images: Image[] = (await getGroupImages(String(giftWrapping?.groupId), locale)) ?? [];

  return { ...giftWrapping, images };
};
